var exports = {
  "A": "outer__GxZvDe",
  "v": "inner__BgjhSm",
};

module.exports = exports;
